export const MUTATION_GROUP = 'cascadingSelectFields' as const;
